import { render, staticRenderFns } from "./draftCheckbox.vue?vue&type=template&id=03265c18&"
import script from "./draftCheckbox.vue?vue&type=script&lang=js&"
export * from "./draftCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports